







export default {
  name: "BaseCheckbox",
  props: {
    value: {
      type: Boolean,
    },
    halfCheck: {
      type: Boolean,
      default: false,
    },
  },
  beforeUpdate() {
    this.$refs.checkbox.checked = this.value;
  },
  mounted() {
    this.$refs.checkbox.checked = this.value;
    //this.updateSelf(this.value);
    //this.$forceUpdate();
  },
  methods: {
    updateSelf(value) {
      this.$emit("input", value);
      this.$refs.checkbox.blur();
    },
  },
};
